import { l as lucia } from "../../../../../chunks/auth.js";
const POST = async ({ locals, cookies }) => {
  if (locals.session) {
    await lucia.invalidateSession(locals.session.id);
  }
  const blank = lucia.createBlankSessionCookie();
  cookies.set(blank.name, blank.value, { path: ".", ...blank.attributes });
  return new Response(null, { status: 204 });
};
export {
  POST
};
